import { io } from "socket.io-client";
import { SOCKET_URL } from "../constants";

let socket = null;

function normalizeToken(token) {
  if (!token) return "";
  const value = String(token).trim();
  return value.startsWith("Bearer ") ? value : `Bearer ${value}`;
}

export function getAppSocket() {
  return socket;
}

export function connectAppSocket(token) {
  const authToken = normalizeToken(token);
  if (!authToken) return null;

  if (socket) {
    const sameToken = socket.auth?.token === authToken;
    socket.auth = { token: authToken };
    if (!sameToken && socket.connected) {
      socket.disconnect();
      socket.connect();
    } else if (!socket.connected) {
      socket.connect();
    }
    return socket;
  }

  socket = io(SOCKET_URL, {
    autoConnect: false,
    // The live API accepts long-polling and rejects a direct websocket.
    transports: ["polling"],
    upgrade: false,
    reconnection: true,
    reconnectionAttempts: 12,
    reconnectionDelay: 1000,
    auth: { token: authToken },
  });

  socket.connect();
  return socket;
}

export function disconnectAppSocket() {
  if (!socket) return;
  socket.removeAllListeners();
  socket.disconnect();
  socket = null;
}

export const connectNotificationSocket = connectAppSocket;
export const getNotificationSocket = getAppSocket;
export const disconnectNotificationSocket = disconnectAppSocket;

const socketApi = {
  getAppSocket,
  connectAppSocket,
  disconnectAppSocket,
  getNotificationSocket,
  connectNotificationSocket,
  disconnectNotificationSocket,
};

export default socketApi;
